import { Fragment } from 'react';
import { string, bool } from 'prop-types';
import Link from 'jl-design-system/elements/link/Link';
import classnames from 'classnames';

import styles from './TreatmentCategory.scss';
import { getTokenFromStorage } from '~/components/persist-token/persist-token.utils';

export const TreatmentCategory = ({
  id,
  thumbnailImg,
  name,
  description,
  isNewBrandPageFeatureEnabled,
}) => (
  <article
    className={[styles.TreatmentCategory, styles.Card].join(' ').trim()}
    data-testid="treatment-category"
  >
    <Link
      to={`treatment-category/${id}${getTokenFromStorage() ? `?token=${getTokenFromStorage()}` : ''}`}
      className={styles.Link}
    >
      <figure className={styles.Image}>
        <img src={thumbnailImg} alt={name} className="img-fluid" />
      </figure>
      {isNewBrandPageFeatureEnabled && (
        <div className={styles.Body}>
          <h4 className={styles.Name} data-testid="TreatmentCategoryName">
            {name}
          </h4>
        </div>
      )}
    </Link>
    {!isNewBrandPageFeatureEnabled && (
      <Fragment>
        <div className={styles.Body}>
          <h4 className={styles.Name} data-testid="TreatmentCategoryName">
            {name}
          </h4>
          <p className={styles.Description} data-testid="TreatmentCategoryDescription">
            {description}
          </p>
        </div>
        <div className={styles.Footer}>
          <Link
            to={`treatment-category/${id}${getTokenFromStorage() ? `?token=${getTokenFromStorage()}` : ''}`}
            className={classnames(styles.Link, styles.UnderlinedLink)}
          >
            Browse
            {` ${name}`}
          </Link>
        </div>
      </Fragment>
    )}
  </article>
);

TreatmentCategory.propTypes = {
  id: string.isRequired,
  thumbnailImg: string.isRequired,
  name: string.isRequired,
  description: string.isRequired,
  isNewBrandPageFeatureEnabled: bool.isRequired,
};
